import React from 'react';
import { Card, Col } from 'react-bootstrap';
import './Course.css'
const Course = (props) => {
    const { rating, price, image, student, name } = props.data;

    return (
        <div>
            <Col>

                <Card className="card">
                    <Card.Img variant="top" src={image} className="image" />
                    <Card.Body >
                        <Card.Title className="title">{name}</Card.Title>
                        <p><b>Price:</b> ${price}</p>
                        <p><b>Ratting:</b> {rating}/5</p>
                        <p><b>Enroll-Student:</b> {student}</p>
                    </Card.Body>
                    <button>Read More &#8594;</button>
                </Card>
            </Col>
        </div>
    );
};

export default Course;